import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ga } from "@util/ga";
import { WSCalendarComponent } from '@web/app/pages/calendar/calendar.component';
import { toasty } from "@web/util/toast";
import { VwReservation } from '@interfaces/dws/reservation';
import { Employee } from '@interfaces/dws/employee';
import { Room } from '@interfaces/dws/room';
import { ReservationComponent } from '../reservation/reservation.component';


@Component({
  selector: 'app-grouped-reservations',
  templateUrl: './grouped-reservations.component.html',
  styleUrls: ['./grouped-reservations.component.scss']
})
export class GroupedReservationsComponent implements OnInit {
  reservation?: VwReservation;
  byGift?: boolean;
  returnGift?: boolean;
  wsCalendarComponent?: WSCalendarComponent;
  rooms: Room[] = [];
  employees: Employee[] = [];
  multiLanguage: boolean = false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dlg: MatDialogRef<GroupedReservationsComponent>,
    private dialog: MatDialog,
  ) {
    if (data.reservation) this.reservation = data.reservation;
    if (data.dashboardComponent) this.wsCalendarComponent = data.dashboardComponent;
    if (data.byGift) this.byGift = data.byGift;
    if (data.employees) this.employees = data.employees;
    if (data.rooms) this.rooms = data.rooms;
    if (data.multiLanguage !== undefined) this.multiLanguage = data.multiLanguage;
  }

  ngOnInit(): void {
    ga.track(`Grouped Reservation ${this.reservation?.id}`);
  }

  closeClicked() {
    this.dlg.close();
  }

  addClicked() {
    this.wsCalendarComponent?.openReservationDialogWithLoadDataCloned(this.reservation!.id!);
  }

  detailsClicked(reservation: VwReservation) {
    console.log('detailsClicked', reservation);
    if (this.wsCalendarComponent) {
      const isPending = this.wsCalendarComponent.requestIdIsPending(reservation.id!);
      if (isPending) {
        const mex = this.wsCalendarComponent.generatePendingMessage();
        if (mex) {
          toasty(mex)
            .position('bottom')
            .duration(5000)
            .present();
        }
        return;
      }
      this.wsCalendarComponent.openReservationDialogWithLoadData(reservation);
      return;
    }

    if (reservation.id) {
      this.dialog.open(ReservationComponent, {
        width: "98vw",
        maxWidth: "1150px",
        data: { reservationId: reservation.id },
      });
    }
  }

  returnToGift() {
    this.dlg.close({
      returnGift: true
    });
  }
}
